import styled from '@emotion/styled';

const Accordion = ({ title, content, isActive, onToggle }) => {
  return (
    <AccordionItem>
      <div className="accordion-title" onClick={onToggle}>
        <div>{isActive ? '-' : '+'}</div>
        <div>{title}</div>
      </div>
      {isActive && (
        <div className="accordion-content" dangerouslySetInnerHTML={{ __html: content }} />
      )}
    </AccordionItem>
  );
};

const AccordionItem = styled.div`
  display: flex;
  flex-flow: column;
  gap: 12px;
  padding: 0 0 24px;

  .accordion-title {
    display: flex;
    font-weight: 600;
    gap: 12px;
  }

  .accordion-content {
    padding: 0 24px;
  }
`;

export default Accordion;
